import React, { useState } from 'react';
import axios from 'axios';
import '../styles/contentRequest.css';

const WritingAnalysisForm = () => {
  const [formData, setFormData] = useState({
    Name: '',
    Email: '',
    'LinkedIn URL': '',
    'Post 1': '',
    'Post 2': '',
    'Post 3': '',
    'Post 4': '',
    'Post 5': '',
    'Post 6': '',
    'Post 7': ''
  });

  const [status, setStatus] = useState({
    loading: false,
    error: null,
    success: false
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, error: null, success: false });

    try {
      await axios.post('https://n8n.iniai.cloud/webhook/linkedin-writing-analysis', formData, {
        headers: {
          'x-api-key': 'auth_k_2f9a8b3c7d6e4f5g9h8i1j2k3l4m5n6',
          'Content-Type': 'application/json'
        }
      });


setStatus({ loading: false, error: null, success: true });

// Add redirect here, before the form reset
window.location.href = `/writinganalysisresult/${encodeURIComponent(formData.Name)}`;

setFormData({
  Name: '',
  Email: '',
  'LinkedIn URL': '',
  'Post 1': '',
  'Post 2': '',
  'Post 3': '',
  'Post 4': '',
  'Post 5': '',
  'Post 6': '',
  'Post 7': ''
});
    } catch (error) {
      setStatus({ 
        loading: false, 
        error: error.message || 'Something went wrong', 
        success: false 
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="content-request-container">
      <div className="content-request-header">
        <h2>Writing Analysis Form</h2>
        <p>Submit LinkedIn posts for writing style analysis</p>
      </div>
      
      <form onSubmit={handleSubmit} className="content-request-form">
        <div className="form-group">
          <label htmlFor="Name">Name</label>
          <input
            type="text"
            id="Name"
            name="Name"
            value={formData.Name}
            onChange={handleChange}
            required
            placeholder="Your full name"
          />
        </div>

        <div className="form-group">
          <label htmlFor="Email">Email</label>
          <input
            type="email"
            id="Email"
            name="Email"
            value={formData.Email}
            onChange={handleChange}
            required
            placeholder="Your email address"
          />
        </div>

        <div className="form-group">
          <label htmlFor="LinkedIn URL">LinkedIn URL</label>
          <input
            type="url"
            id="LinkedIn URL"
            name="LinkedIn URL"
            value={formData['LinkedIn URL']}
            onChange={handleChange}
            placeholder="Your LinkedIn profile URL"
          />
        </div>

        {[1, 2, 3, 4, 5, 6, 7].map(num => (
          <div className="form-group" key={num}>
            <label htmlFor={`Post ${num}`}>Post {num}</label>
            <textarea
              id={`Post ${num}`}
              name={`Post ${num}`}
              value={formData[`Post ${num}`]}
              onChange={handleChange}
              placeholder={`Paste your LinkedIn post ${num} here`}
              rows="4"
            />
          </div>
        ))}

        {status.error && <div className="status-message status-error">{status.error}</div>}
        {status.success && <div className="status-message status-success">Analysis request submitted successfully!</div>}

        <button type="submit" disabled={status.loading}>
          {status.loading ? 'Analyzing...' : 'Submit for Analysis'}
        </button>
      </form>
    </div>
  );
};

export default WritingAnalysisForm;